import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { global } from '../../shared/global';
import 'rxjs/add/operator/map';
import { CreateshopService } from '../createshop/createshop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  termConditionLink: any;
  cutomerLink: any;
  shopkeeperLink: any;

  customerCookie: any;
  customerTitle: any;

  shopkeeperCookie: any;
  shopkeeperData: any;
  shopkeeperTitle: any;

  staffCookie: any;
  staffTitle: any;

  constructor(private cookieService : CookieService, private service: CreateshopService, private spinner: NgxSpinnerService, private router: Router) {}

  ngOnInit() {
    this.termConditionLink = global.termConditionLink;
    this.cutomerLink = global.baseAPIUrl + "android/live/CUSTOMER%20MANUAL.pdf";
    this.shopkeeperLink = global.baseAPIUrl + "android/live/SHOPKEEPER%20MANUAL.pdf";

    this.customerCookie = this.cookieService.get("login");
    this.shopkeeperCookie = this.cookieService.get("shop");
    this.staffCookie = this.cookieService.get("staff");

    if (this.customerCookie) {
      this.customerCookie = JSON.parse(this.customerCookie)
      // this.customerTitle = "Continue as " + this.customerCookie.mobile;
      this.customerTitle = "Go to Customer View";
    }
    else {
      this.customerTitle = "Go to Customer View";
    }

    if (this.shopkeeperCookie) {
      // this.spinner.show();
      // this.shopkeeperCookie = JSON.parse(this.shopkeeperCookie);
      
      // var data = {
      //   "companyid":this.shopkeeperCookie.companyid
      // }
      // this.service.getShopInfo(data)
      // .subscribe(shopData => {
      //   this.shopkeeperData = shopData;

      //   if (this.shopkeeperData.isSuccess == false) {
      //   }
      //   else {
      //     // this.shopkeeperTitle = "Continue as " + this.shopkeeperData.data.name;
      //     this.spinner.hide();
      //   }
      // });
      this.shopkeeperTitle = "Go to Vendor View";
    } else {
      this.shopkeeperTitle = "Go to Vendor View";
    }

    if (this.staffCookie) {
      this.staffCookie = JSON.parse(this.staffCookie)
      // this.customerTitle = "Continue as " + this.customerCookie.mobile;
      this.staffTitle = "Go to Staff View";
    }
    else {
      this.staffTitle = "Go to Staff View";
    }
  }

  setStaffConfig() {
    var objConfig = {
      "isStaff":1
    }

    this.cookieService.set("config", JSON.stringify(objConfig));
  }

  setVendorConfig() {
    var objConfig = {
      "isStaff":0
    }

    this.cookieService.set("config", JSON.stringify(objConfig));
  }
}